import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import AccessTimePatternTab from "../../../containers/access-time-pattern-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import { Filter } from "../../../models/Filter";
import { getListOfSiteIdsFromFilter, shouldUpdateCategory } from "../../../utilities/tabUtils";
import { useTabCount } from "@/hooks/useCategoryTab";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}
const AccessTimePatterns: FC = () => {
    const [busy, setBusy] = useState(false);
    const { translate } = useLocale();
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [selected, setSelected] = useState(0);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));
    const { updateTabCount } = useTabCount({
        tableName: "AccessTimePattern",
        categories,
        setCategories,
    });

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.accessTimePatterns),
                    heading: translate.byKey(TranslationKeys.accessTimePatterns),
                    value: "",
                    id: 0,
                    count: 1,
                },
            ]);
            setBusy(false);

        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <AccessTimePatternTab setBusy={setBusy} categories={categories} onFilterChange={onFilterChange} setCategories={setCategories}></AccessTimePatternTab>,
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters: Filter[]) => {
        updateTabCount(getListOfSiteIdsFromFilter(filters));
    }
    
    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/enrolment",
                                displayName: translate.byKey(TranslationKeys.enrolments),
                            },
                            {
                                value:
                                    "/access-control/enrolment/access-time-patterns",
                                displayName: translate.byKey(TranslationKeys.accessTimePatterns),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row justify-end button-cluster">
                                <Restricted to={`add.${routeName}.element`}>
                                    <Link
                                        to={{
                                            pathname:
                                                "/access-control/enrolment/access-time-pattern/",
                                        }}>
                                        <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id="addBtn">
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt=""
                                            />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default AccessTimePatterns;
